<template>
    <div class="alert alert-warning" role="alert">
        <div class="alert-content">
            <i class="fas mr-2 fa-bell-exclamation" />

            <slot></slot>
        </div>
    </div>
</template>
  
<script>
export default {
    name: "WarningMessage",
};
</script>

<style scoped>
.alert-content {
    color: #af6708;
}
</style>